import React from "react";
import { Icon } from "antd";
import Button from "theme/Button";
import $ST from "plugins/tfs/platformConfigs/staticTextMaps/checkout";

import ThankYou from "_pageContainers/checkout/thankyou";

import "./style.less";

const ThankYouGrid = (pageContext) => {
  const {
    onGoBackHomeButtonClick,
    props: { orderNumber },
  } = pageContext;

  return (
    <div className="checkout-thank-you-tfs">
      <div className="checkout-thank-you-tfs__wrapper">
        <div className="checkout-thank-you-tfs__icon-container">
          <div className="checkout-thank-you-tfs__icon">
            <Icon type="check" />
          </div>
        </div>
        <h1 className="checkout-thank-you-tfs__title">{$ST.ORDER_RECEIVED}</h1>
        <p className="checkout-thank-you-tfs__subtitle">{$ST.CHECK_INBOX}</p>
        <p className="checkout-thank-you-tfs__order-number">
          {$ST.ORDER_NUMBER_TEXT} <b>{orderNumber}</b>
        </p>
        <h2 className="checkout-thank-you-tfs__section-title">
          {$ST.WHAT_IS_NEXT}
        </h2>
        <p className="checkout-thank-you-tfs__text">
          {$ST.SHIPPING_EMAIL_TEXT}
        </p>
        <p className="checkout-thank-you-tfs__text">{$ST.THANK_YOU_SHOPPING}</p>
        <p className="checkout-thank-you-tfs__text">{$ST.CONTACT_US}</p>
        <p className="checkout-thank-you-tfs__signature">{$ST.SIGNATURE}</p>
        <Button
          className="button checkout-thank-you-tfs__button"
          onClick={onGoBackHomeButtonClick}
        >
          {$ST.BACK_TO_HOMEPAGE}
        </Button>
      </div>
    </div>
  );
};

export default ThankYou(ThankYouGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/checkout/thankyou/index.js